import { Constants } from "../Constants";
import BaseApi from "./BaseApi";

class ValhallaApi extends BaseApi {
  constructor() {
    super(
      process.env.REACT_APP_valhallaApiUrl,
      Constants.USER_TOKEN_KEY,
      Constants.USER_TOKEN_EXPIRATION
    );
    this.getApplicationId = this.getApplicationId.bind(this);
  }

  async getUserInfo() {
    const response = await this.getAxios().get(
      "/applicationsecurity/getuserinfo/"
    );
    return response;
  }

  async saveUserInfoPartial(identityUser) {
    const response = await this.getAxios().post(
      "/applicationsecurity/saveuserinfopartial/",
      identityUser
    );
    return response;
  }

  async isUserLicensedAdministrator() {
    const params = { params: { applicationName: Constants.APPLICATION_NAME } };
    const response = await this.getAxios().get(
      "/applicationsecurity/isuserlicensedadministrator/",
      params,
      this.jsonEncoded
    );
    return response;
  }

  async isUserLocationApplicationAdministrator() {
    const params = { params: { applicationName: Constants.APPLICATION_NAME } };
    const response = await this.getAxios().get(
      "/applicationsecurity/isuserlocationdapplicationadministrator/",
      params,
      this.jsonEncoded
    );
    return response;
  }

  async isUserLocationAdministrator() {
    const response = await this.getAxios().get(
      "/applicationsecurity/isuserlocationdadministrator/"
    );
    return response;
  }

  async getHospitalityGroup(hospitalityGroupId) {
    const response = await this.getAxios().get("/hospitalitygroup/", {
      params: { hospitalityGroupId },
    });
    return response;
  }

  async getApplicationByName() {
    const response = await this.getAxios().get("/application/getbyname", {
      params: { applicationName: Constants.APPLICATION_NAME },
    });
    return response;
  }

  async createSubscription(subscriptionRequest) {
    const response = await this.getAxios().post(
      "/subscription/create",
      subscriptionRequest
    );
    return response;
  }

  async updateSubscriptionStatus(subscription) {
    const response = await this.getAxios().post(
      "/subscription/updatestatus",
      subscription
    );
    return response;
  }

  async getSubscriptionBillingDetails() {
    const params = {
      params: {
        hospitalityGroupId: this.getHospitalityGroupId(),
        applicationId: this.getApplicationId(),
      },
    };
    const response = await this.getAxios().get(
      "/subscription/getsubcriptionbillingdetails/",
      params
    );
    return response;
  }

  async retryInvoice(retryInvoiceRequest) {
    const response = await this.getAxios().post(
      "/subscription/retryinvoice",
      retryInvoiceRequest
    );
    return response;
  }
  async getAdministratorHospitalityGroups() {
    const params = {
      params: { applicationContext: Constants.APPLICATION_NAME },
    };
    const response = await this.getAxios().get(
      "/applicationsecurity/getadministratorhospitalitygroups/",
      params
    );
    return response;
  }

  async getApplicationRoles() {
    const params = {
      params: { applicationContext: Constants.APPLICATION_NAME },
    };
    const response = await this.getAxios().get(
      "/applicationsecurity/getapplicationroles/",
      params
    );
    return response;
  }

  async getUsersAndRoles() {
    const params = {
      params: {
        hospitalityGroupId: this.getHospitalityGroupId(),
        applicationContext: Constants.APPLICATION_NAME,
      },
    };
    const response = await this.getAxios().get(
      "/applicationsecurity/getusersandroles/",
      params
    );
    return response;
  }

  /*
  Pass an object containing the following properties
    applicationUserId - get this from the original result set for users and roles
    applicationRoleId - this is the key from the list of roles provided by getApplicationRoles
    locationId - you will get this from getManagedLocations() on the safefunapi
  */
  async addUserToRole(request) {
    const response = await this.getAxios().post(
      "/applicationuserrolelocation/buildandcreate",
      request
    );
    return response;
  }

  /*
  Pass an object containing the following properties
    applicationUserRoleLocationId - key for the user/role/location combo - found on the original result for users and role
    applicationUserId - get this from the original result set for users and roles
    applicationRoleId - this is the key from the list of roles provided by getApplicationRoles
    locationId - you will get this from getManagedLocations() on the safefunapi
  */
  async updateUserRole(applicationUserRoleLocation) {
    const response = await this.getAxios().post(
      "/applicationuserrolelocation/update",
      applicationUserRoleLocation
    );
    return response;
  }

  /*
  Pass an object containing the following properties
    applicationUserRoleLocationId - get this from the original result set for users and roles
  */
  async deleteUserRole(applicationUserRoleLocation) {
    const response = await this.getAxios().post(
      "/applicationuserrolelocation/delete",
      applicationUserRoleLocation
    );
    return response;
  }

  getApplicationId() {
    return parseInt(window.localStorage.getItem(Constants.APPLICATION_ID));
  }
  getStripePriceId() {
    return window.localStorage.getItem(Constants.STRIPE_PRICE_ID);
  }
}

export default ValhallaApi;
